import store from '@apply/adminStore';
import { onApplicationActionItem } from '../../../ApplicationFunctions';

export const performCellDoubleClick = (e, actionType) => {
    const { dispatch } = store;
    if (e.rowType !== 'data' || e.column.type === 'detailExpand' || e.column.type === 'actions') {
        return;
    }
    const model = {
        actionId: actionType,
        id: e.data.id,
        propertyId: e.data.propertyId,
    };
    onApplicationActionItem(dispatch, model.actionId, model.id, model.propertyId);
};
